import React from "react";
import "./styles.scss";
import LifetimeUsage from "./lifeTimeUsage";
import AverageSessionTime from "./averageSessionTime";
import DMS from "./dms/index";
import Installs from "./installs";
import Ratings from "./ratings";

const AppAnalytics = ({ app }) => {

    return (
        <>
                <div className="d-flex">
                    <div className="card p_all-20 pt-20 flex-point-65">
                        <Ratings app={app} />
                    </div>
                    <div className="card flex-size-0.4 p_all-20 flex-point-45">
                    <LifetimeUsage app={app} />

                        <Installs app={app} />
                    </div>
                </div>
                <div className="d-flex d-justify-evenly">
                    <LifetimeUsage app={app} />
                    <AverageSessionTime app={app} />
                </div>
                <div className="d-flex d-justify-evenly">
                    <DMS app={app} />
                </div>
        </>
    )
}

export default AppAnalytics; 